import { Card } from 'components/Card';
import { CardRow } from 'components/CardRow';
import { ModalScreenProps, ModalScreens } from 'components/Navigation/types';
import { Page } from 'components/Page';
import { PageHeader } from 'components/PageHeader';
import { useEsc } from 'hooks/useEsc';
import { useSelector } from 'hooks/useSelector';
import React from 'react';
import { useDispatch } from 'react-redux';
import {
  NAVIGATE_MODAL_BACK,
  SET_ASSETS_FILTER,
  SET_ASSETS_SORT,
} from 'store/actions';
import {
  selectAssetListSort,
  selectOrganisationFilterValue,
} from 'store/assets/selectors';
import { AssetsSortOrder } from 'store/assets/types';
import { selectOrganisationFilterOptions } from 'store/organisations/selectors';

const SortValues: { text: string; value: AssetsSortOrder; sort: number }[] = [
  {
    text: 'Name A-Z',
    value: AssetsSortOrder.NAMEASC,
    sort: 1,
  },
  {
    text: 'Name Z-A',
    value: AssetsSortOrder.NAMEDESC,
    sort: 2,
  },
  {
    text: 'Assessment Due',
    value: AssetsSortOrder.ASSESSMENTDUEASC,
    sort: 3,
  },
];

export const LocalAssetsFilterModal: React.FC<
  ModalScreenProps<ModalScreens.OfflinePropertyListFilter>
> = () => {
  const dispatch = useDispatch();
  const assetsListSort = useSelector(selectAssetListSort);
  const organisationFilterOptions = useSelector(
    selectOrganisationFilterOptions,
  );
  const organisationFilterValue = useSelector(selectOrganisationFilterValue);

  const [filter, setFilter] = React.useState({
    sort: assetsListSort,
    organisation: organisationFilterValue,
  });

  const handleClose = () => {
    dispatch(NAVIGATE_MODAL_BACK());
  };

  const handleApply = () => {
    dispatch(
      SET_ASSETS_FILTER({
        organisations: filter.organisation ? [filter.organisation] : [],
      }),
    );
    dispatch(SET_ASSETS_SORT(filter.sort));
    handleClose();
  };

  useEsc(handleClose);

  return (
    <Page
      scrollView
      header={
        <PageHeader
          title="Filter"
          onPressCancelButton={handleClose}
          onPressSaveButton={handleApply}
        />
      }
    >
      {organisationFilterOptions.length > 1 && (
        <Card label="Organisations">
          <CardRow
            label={'All Organisations'}
            radioValue={!filter.organisation}
            onPress={() =>
              setFilter((c) => ({ ...c, organisation: undefined }))
            }
          />
          {organisationFilterOptions.map((option) => (
            <CardRow
              key={option.id}
              label={option.name}
              radioValue={option.id === filter.organisation}
              onPress={() =>
                setFilter((c) => ({ ...c, organisation: option.id }))
              }
            />
          ))}
        </Card>
      )}

      <Card label="Sort">
        {SortValues.map((option) => (
          <CardRow
            key={option.value}
            label={option.text}
            radioValue={option.value === filter.sort}
            onPress={() => setFilter((c) => ({ ...c, sort: option.value }))}
          />
        ))}
      </Card>
    </Page>
  );
};
